import { Scene } from 'components/Scene';

export default Scene;
